import React, { Fragment } from "react";

import { ProductPrice } from "@components/Product/Layout/ProductPrice/productPrice.component";

type PriceBlockProps = {
    currentPrice: number;
    strikethroughPrice?: number | null;
};

const PriceBlock = ({ currentPrice, strikethroughPrice }: PriceBlockProps) => {
    const hasPromotion = !!strikethroughPrice;

    return (
        <Fragment>
            {hasPromotion && (
                <div className="row d-flex justify-content-md-end mr-0">
                    <ProductPrice
                        price={strikethroughPrice!}
                        size="large"
                        variant="promo"
                    />
                </div>
            )}
            <div
                className={`row d-flex justify-content${
                    hasPromotion ? "-md" : ""
                }-end mr-0`}
            >
                <ProductPrice
                    price={currentPrice}
                    size="large"
                />
            </div>
        </Fragment>
    );
};

export default PriceBlock;
